// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-input-style {
  border: 1px solid gray;
  border-radius: 5px;
  font-size: 16px;
  width: 40px;
  height: 40px;
  margin: 0 5px;
  text-align: center;
}

.otp-input-style:focus {
  outline: none;
  border-color: blue;
}
`, "",{"version":3,"sources":["webpack://./src/Admin/otp/otp.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".otp-input-style {\n  border: 1px solid gray;\n  border-radius: 5px;\n  font-size: 16px;\n  width: 40px;\n  height: 40px;\n  margin: 0 5px;\n  text-align: center;\n}\n\n.otp-input-style:focus {\n  outline: none;\n  border-color: blue;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
